export default __webpack_public_path__ + "static/media/icon-account-balance.7f8960fd.svg";